var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"container3",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0),_c('div',{staticClass:"info"},[_vm._v(" 请点击右上角转发 ")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imagebox"},[_c('img',{attrs:{"src":require("@/assets/images/hvac/mapping/jiantou.png"),"alt":""}})])
}]

export { render, staticRenderFns }